const actionKeys = {
  loadData: 'LoadData',
  add: 'Add',
  remove: 'Remove',
  clear: 'Clear',
};

const loadData = (playbooks = []) => async (dispatch) => {
  dispatch({
    type: actionKeys.loadData,
    payload: {
      playbooks,
    },
  });
};

const add = (playbook) => async (dispatch) => {
  dispatch({
    type: actionKeys.add,
    payload: {
      playbook,
    },
  });
};

const remove = (playbookRn) => async (dispatch) => {
  dispatch({
    type: actionKeys.remove,
    payload: {
      playbookRn,
    },
  });
};

const clear = () => async (dispatch) => {
  dispatch({
    type: actionKeys.clear,
  });
};

const defaultState = {
  allPlaybooks: [],
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionKeys.loadData:
      return {
        ...state,
        allPlaybooks: action.payload.playbooks,
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.add:
      return {
        ...state,
        allPlaybooks: [
          ...state.allPlaybooks.filter((playbook) => playbook.playbookRn !== action.payload.playbook.playbookRn),
          action.payload.playbook,
        ],
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.remove:
      return {
        ...state,
        allPlaybooks: state.allPlaybooks.filter((playbook) => playbook.playbookRn !== action.payload.playbookRn),
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.clear:
      return defaultState;
    default:
      return state;
  }
};

export default {
  actions: {
    loadData,
    add,
    remove,
    clear,
  },
  defaultState,
  reducer,
};
